import { getTemplateData } from '@/scripts/utils/cms';
import loadScript from '../lib/loadScript';

export default function initAnalytics() {

   /* Google Tag Manager */
   (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
   })(window,document,'script','dataLayer',process.env.GTM_ID);
   /* Google Analytics */
   (function (i, s, o, g, r, a, m) {
      i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () {
         (i[r].q = i[r].q || []).push(arguments);
      }, i[r].l = 1 * new Date(); a = s.createElement(o),
         m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; a.type='javascript/privado-block'; a.setAttribute('privado-cookie-category', 'C002'); m.parentNode.insertBefore(a, m);
   })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

   if (window.ga) {
      window.ga('create', process.env.UA_ID, 'auto');
   }

   //FullStory
   if (process.env.FS_ORG) {
      window._fs_debug = false;
      window._fs_host = 'fullstory.com';
      window._fs_org = process.env.FS_ORG;
      window._fs_namespace = 'FS';

      (function (m, n, e, t, l, o, g, y) {
         if (e in m && m.console && m.console.log) {
            m.console.log('FullStory namespace conflict. Please set window._fs_namespace.');
            return;
         }
         g = m[e] = function (a, b) {
            g.q ? g.q.push([a, b]) : g._api(a, b);
         };
         g.q = [];
         o = n.createElement(t);
         o.async = 1;
         o.src = 'https://' + window._fs_host + '/s/fs.js';
         y = n.getElementsByTagName(t)[0];
         y.parentNode.insertBefore(o, y);
         g.identify = function (i, v) {
            g(l, { uid: i });
            if (v) g(l, v);
         };
         g.setUserVars = function (v) {
            g(l, v);
         };
         g.identifyAccount = function (i, v) {
            o = 'account';
            v = v || {};
            v.acctId = i;
            g(o, v);
         };
         g.clearUserCookie = function (c, d, i) {
            if (!c || document.cookie.match('fs_uid=[`;`]*`[`;`]*`[`;`]*`')) {
               d = n.domain;
               while (1) {
                  n.cookie = 'fs_uid=;domain=' + d +
                     ';path=/;expires=' + new Date(0).toUTCString();
                  i = d.indexOf('.');
                  if (i < 0) break;
                  d = d.slice(i + 1);
               }
            }
         };
      })(window, document, window['_fs_namespace'], 'script', 'user');
   }

   if (process.env.FB_PIXEL) {
      !function (f, b, e, v, n, t, s) {
         if (f.fbq) return;
         n = f.fbq = function () {
            n.callMethod ?
               n.callMethod.apply(n, arguments) : n.queue.push(arguments);
         };
         if (!f._fbq) f._fbq = n;
         n.push = n;
         n.loaded = !0;
         n.version = '2.0';
         n.queue = [];
         t = b.createElement(e);
         t.async = !0;
         t.src = v;
         s = b.getElementsByTagName(e)[0];
         s.parentNode.insertBefore(t, s);
      }(window, document, 'script',
         'https://connect.facebook.net/en_US/fbevents.js');
      if (window.fbq) {
         window.fbq('init', process.env.FB_PIXEL);
         window.fbq('track', 'PageView');
      }
   }

}